import React from 'react';
import { Card } from '../ui/Card';
type DiveConsistencyHeatmapProps = {
  data: {
    month: string;
    count: number;
  }[];
};
export const DiveConsistencyHeatmap: React.FC<DiveConsistencyHeatmapProps> = ({
  data
}) => {
  // Find max count for color intensity calculation
  const maxCount = Math.max(...data.map(item => item.count));
  return <Card data-id="element-248">
      <h3 className="font-semibold mb-4" data-id="element-249">Diving Consistency</h3>
      <div className="grid grid-cols-6 gap-2" data-id="element-250">
        {data.map((item, index) => {
        // Calculate opacity based on dive count (0.1 to 1)
        const opacity = item.count === 0 ? 0.1 : 0.2 + item.count / maxCount * 0.8;
        return <div key={index} className="flex flex-col items-center" data-id="element-251">
              <div className="w-full aspect-square rounded-md mb-1" style={{
            backgroundColor: `rgba(0, 102, 204, ${opacity})`
          }} data-id="element-252"></div>
              <span className="text-xs text-gray-500" data-id="element-253">{item.month}</span>
              <span className="text-xs font-medium" data-id="element-254">{item.count}</span>
            </div>;
      })}
      </div>
      <div className="flex justify-between items-center mt-3" data-id="element-255">
        <div className="text-xs text-gray-500" data-id="element-256">Less</div>
        <div className="flex gap-1" data-id="element-257">
          {[0.1, 0.3, 0.5, 0.7, 0.9].map((opacity, index) => <div key={index} className="w-4 h-4 rounded-sm" style={{
          backgroundColor: `rgba(0, 102, 204, ${opacity})`
        }} data-id="element-258"></div>)}
        </div>
        <div className="text-xs text-gray-500" data-id="element-259">More</div>
      </div>
    </Card>;
};